module.exports = __webpack_public_path__ + "img/pd-img-body1.048ccb9a.png";